<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: '违规预警列表' }">违规预警</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">添加违规预警消息</template>
      <template slot="tools">
        <router-link :to="{name: '违规预警列表'}">
          <el-button size="small" icon="el-icon-back">返回列表</el-button>
        </router-link>
      </template>

      <el-form ref="form"
               :model="form"
               :rules="rules"
               label-width="120px"
               size="medium"
               class="create-form">
        <div class="section-title">通知内容</div>
        <el-form-item label="违规类型" prop="violation_type_id">
          <el-select v-model="form.violation_type_id"
                     class="width-max"
                     filterable
                     placeholder="请选择违规类型"
                     @change="onTypeChange">
            <el-option v-for="item in typeOptions"
                       :key="item.id"
                       :label="item.name"
                       :value="Number(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息内容" prop="content">
          <el-input v-model="form.content" type="textarea" :rows="4" maxlength="300" placeholder="请输入消息内容，限300字"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="image">
          <el-upload
            ref="upload"
            class="avatar-uploader"
            :auto-upload="false"
            action=""
            accept="image/png,image/jpeg"
            :show-file-list="false"
            :on-change="onChangeFile">
            <img v-if="form.image" :src="form.image" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-button v-if="form.image" type="text" class="danger-text" @click="form.image = ''">移除图片</el-button>
          <div class="upload-tip">非必填，最多 1 张；JPG/PNG，≤5MB</div>
        </el-form-item>

        <div class="section-title">处理结果</div>
        <el-form-item label="处理方式" prop="action">
          <el-select v-model="form.action" class="width-max" placeholder="请选择处理方式">
            <el-option v-for="item in actionOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <template v-if="form.action === ACTION_DEDUCT_POINT">
          <el-form-item label="扣除零豆">
            <el-input v-model.number="form.punish_point" type="number" min="0">
              <template slot="append">个</template>
            </el-input>
          </el-form-item>
          <el-form-item label="扣除赏金">
            <el-input v-model.number="form.punish_salary" type="number" min="0" step="0.01">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <div class="field-tip">两个字段至少填一个，均为大于 0 才生效；扣除赏金 &gt; 0 时必须关联项目</div>
          <el-form-item v-if="Number(form.punish_salary) > 0" label="项目名称" prop="projectid" :required="true">
            <remote-select
              id-key="number"
              label-key="name"
              value-key="id"
              placeholder="请输入项目名称/编号搜索"
              v-model="form.projectid"
              :query-request="getBaiscProjectTable"
              :find-request="getProjectDetail"
              clearable>
            </remote-select>
          </el-form-item>
        </template>

        <template v-if="form.action === ACTION_FORBID_ORDER">
          <el-form-item label="禁止天数" prop="punish_day">
            <el-input v-model.number="form.punish_day" type="number" min="1">
              <template slot="append">天</template>
            </el-input>
          </el-form-item>
        </template>

        <template v-if="form.action === ACTION_BAN">
          <el-form-item label="封号原因" prop="ban_reason">
            <el-select v-model="form.ban_reason" class="width-max" placeholder="请选择封号原因" clearable>
              <el-option v-for="item in banReasonOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="添加黑名单池">
            <el-checkbox-group v-model="form.ban_types">
              <el-checkbox label="idcard">身份证（永久）</el-checkbox>
              <el-checkbox label="phone">手机号（永久）</el-checkbox>
            </el-checkbox-group>
            <div class="blacklist-tips">
              <div>*释：身份证加入黑名单池后，下次用户换号实名该身份证，提示你的身份已冻结</div>
              <div>手机号加入黑名单池，下次用户用此手机号将无法登录，提示该账号已冻结</div>
            </div>
          </el-form-item>
        </template>

        <div class="section-title">发送对象</div>
        <template v-if="form.action === ACTION_BAN">
          <el-form-item label="封号用户" prop="ban_keyword" required>
            <el-input v-model="form.ban_keyword"
                      placeholder="输入用户ID或手机号"
                      clearable>
            </el-input>
            <div class="field-tip">永久封号仅支持单用户操作</div>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="用户选择方式" prop="select_method">
            <el-radio-group v-model="form.select_method">
              <el-radio label="id">用户ID</el-radio>
              <el-radio label="phone">手机号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="用户列表" prop="user_list_text">
            <el-input v-model="form.user_list_text"
                      type="textarea"
                      :rows="5"
                      :placeholder="form.select_method === 'phone' ? '每行一个手机号' : '每行一个用户ID'">
            </el-input>
            <div class="field-tip">
              已输入 {{ userListCount }} / 50 个用户
              <span v-if="userListCount > 50" class="danger-text">（已超出上限，请精简到 50 个以内）</span>
            </div>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button @click="goBack">取消</el-button>
          <el-button type="primary" :loading="resolving" @click="onClickSend">发送</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <el-dialog
      title="确认发送对象"
      :visible.sync="confirmVisible"
      width="720px"
      :close-on-click-modal="false">
      <div class="confirm-desc">
        将向以下 <strong>{{ confirmUsers.length }}</strong> 名用户发送违规预警（本阶段仅保存记录，不真正执行处罚/推送）
      </div>
      <el-table :data="confirmUsers" border size="small" max-height="360">
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="userid" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="cellphone" label="手机号" width="130"></el-table-column>
        <el-table-column prop="name" label="姓名" min-width="120"></el-table-column>
        <el-table-column prop="region" label="所在地区" min-width="160"></el-table-column>
      </el-table>
      <div v-if="missingCount > 0" class="confirm-warn">有 {{ missingCount }} 个用户未匹配，请返回修改</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmVisible = false">返回修改</el-button>
        <el-button type="primary"
                   :loading="saving"
                   :disabled="missingCount > 0 || !confirmUsers.length"
                   @click="onConfirmSend">确认发送</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  ACTION_NOTIFY,
  ACTION_DEDUCT_POINT,
  ACTION_FORBID_ORDER,
  ACTION_BAN,
  ACTION_OPTIONS,
  BAN_REASON_OPTIONS,
} from '../violation-alert.constants'

const emptyForm = () => ({
  violation_type_id: null,
  title: '违规提醒',
  content: '',
  image: '',
  action: ACTION_NOTIFY,
  punish_point: 0,
  punish_salary: 0,
  projectid: 0,
  punish_day: 0,
  ban_reason: null,
  ban_types: [],
  select_method: 'id',
  user_list_text: '',
  ban_keyword: '',
})

export default {
  name: 'ViolationAlertCreate',
  data () {
    return {
      ACTION_DEDUCT_POINT,
      ACTION_FORBID_ORDER,
      ACTION_BAN,
      actionOptions: ACTION_OPTIONS,
      banReasonOptions: BAN_REASON_OPTIONS,
      typeOptions: [],
      form: emptyForm(),
      resolving: false,
      saving: false,
      confirmVisible: false,
      confirmUsers: [],
      rules: {
        violation_type_id: [{required: true, message: '请选择违规类型', trigger: 'change'}],
        content: [{required: true, message: '请填写消息内容', trigger: 'blur'}],
        action: [{required: true, message: '请选择处理方式', trigger: 'change'}],
      },
    }
  },
  computed: {
    userListCount () {
      return this.parseKeywords(this.form.user_list_text).length
    },
    missingCount () {
      return this.confirmUsers.filter(u => !u.exists).length
    },
  },
  created () {
    request.common('violationAlertTypeOptions').then(({data}) => {
      this.typeOptions = (data && data.data) ? data.data : []
    })
  },
  methods: {
    getBaiscProjectTable (params) {
      return request.page('getBaiscProjectTable', params)
    },
    getProjectDetail (params) {
      return request.common('getProjectDetail', params)
    },
    parseKeywords (text) {
      return String(text || '').split('\n').map(s => s.trim()).filter(Boolean)
    },
    goBack () {
      this.$router.push({name: '违规预警列表'})
    },
    onTypeChange (typeId) {
      const type = this.typeOptions.find(t => Number(t.id) === Number(typeId))
      if (!type) return
      this.form.content = type.default_content || (`你的账号因「${type.name}」行为已被记录违规，请尽快在客服中心查看详情并申诉，逾期将影响你的接单权限。`)
      this.form.image = type.default_image || ''
      this.form.action = Number(type.default_action) || ACTION_NOTIFY
      this.form.punish_point = Number(type.default_punish_point) || 0
      this.form.punish_salary = Number(type.default_punish_salary) || 0
      this.form.projectid = Number(type.default_projectid) || 0
      this.form.punish_day = Number(type.default_punish_day) || 0
      this.form.ban_reason = type.default_ban_reason ? Number(type.default_ban_reason) : null
      this.form.ban_types = Array.isArray(type.default_ban_types) ? type.default_ban_types.slice() : []
      this.form.title = '违规提醒'
    },
    onChangeFile (file) {
      const raw = file.raw
      const isImage = raw && (raw.type === 'image/jpeg' || raw.type === 'image/png' || raw.type === 'image/jpg')
      const isLt5M = raw && raw.size / 1024 / 1024 < 5
      if (!isImage) {
        this.$message.error('请上传 JPG / PNG 图片')
        this.$refs.upload.clearFiles()
        return
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        this.$refs.upload.clearFiles()
        return
      }
      const nameParts = String(raw.name || '').split('.')
      const ext = nameParts.length > 1 ? nameParts.pop().toLowerCase() : 'jpg'
      request.common('getSignedOssUrl', {
        file_name: raw.name,
        ext: ext,
        content_type: raw.type || 'image/jpeg',
        biz: 'violation_alert',
      }).then(({data}) => {
        return fetch(data.signedUrl, {
          method: 'PUT',
          headers: new Headers({'Content-Type': data.content_type}),
          body: raw,
        }).then((uploadRes) => {
          if (!uploadRes.ok) throw new Error(`上传失败: ${uploadRes.status}`)
          this.form.image = data.url
          this.$message.success('上传成功')
        })
      }).catch((error) => {
        if (error && error.message) this.$message.error(error.message)
      }).finally(() => {
        this.$refs.upload && this.$refs.upload.clearFiles()
      })
    },
    validateBusiness () {
      if (this.form.action === ACTION_DEDUCT_POINT) {
        const point = Number(this.form.punish_point) || 0
        const reward = Number(this.form.punish_salary) || 0
        if (point <= 0 && reward <= 0) {
          this.$message.error('扣除零豆或赏金时，「扣除零豆」「扣除赏金」至少填一个（大于0）')
          return false
        }
        if (reward > 0 && !(Number(this.form.projectid) > 0)) {
          this.$message.error('扣除赏金时必须关联一个项目')
          return false
        }
      }
      if (this.form.action === ACTION_FORBID_ORDER && !(Number(this.form.punish_day) > 0)) {
        this.$message.error('请填写禁止做单天数（大于0的整数）')
        return false
      }
      if (this.form.action === ACTION_BAN && !this.form.ban_reason) {
        this.$message.error('请选择封号原因')
        return false
      }
      if (this.form.action === ACTION_BAN) {
        if (!String(this.form.ban_keyword || '').trim()) {
          this.$message.error('永久封号必须选择一个用户')
          return false
        }
      } else {
        const keywords = this.parseKeywords(this.form.user_list_text)
        if (!keywords.length) {
          this.$message.error('请填写用户列表')
          return false
        }
        if (keywords.length > 50) {
          this.$message.error('单次违规预警最多支持 50 个用户')
          return false
        }
      }
      return true
    },
    onClickSend () {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        if (!this.validateBusiness()) return

        let method = this.form.select_method
        let keywords = this.parseKeywords(this.form.user_list_text)
        if (this.form.action === ACTION_BAN) {
          const kw = String(this.form.ban_keyword || '').trim()
          keywords = [kw]
          method = /^1\d{10}$/.test(kw) ? 'phone' : 'id'
        }

        this.resolving = true
        request.common('violationAlertRecordResolveUsers', {method, keywords}).then(({data}) => {
          this.confirmUsers = (data && data.data) ? data.data : []
          this.confirmVisible = true
        }).finally(() => {
          this.resolving = false
        })
      })
    },
    buildPayload () {
      const payload = {
        violation_type_id: Number(this.form.violation_type_id),
        title: '违规提醒',
        content: (this.form.content || '').trim(),
        image: this.form.image || '',
        action: Number(this.form.action),
        punish_point: 0,
        punish_salary: 0,
        projectid: 0,
        punish_day: 0,
        ban_reason: 0,
        ban_types: [],
        userids: this.confirmUsers.filter(u => u.exists).map(u => Number(u.userid)),
      }
      if (payload.action === ACTION_DEDUCT_POINT) {
        payload.punish_point = Number(this.form.punish_point) || 0
        payload.punish_salary = Number(this.form.punish_salary) || 0
        payload.projectid = payload.punish_salary > 0
          ? (Number(this.form.projectid) || 0)
          : 0
      } else if (payload.action === ACTION_FORBID_ORDER) {
        payload.punish_day = Number(this.form.punish_day) || 0
      } else if (payload.action === ACTION_BAN) {
        payload.ban_reason = Number(this.form.ban_reason) || 0
        payload.ban_types = (this.form.ban_types || []).slice()
      }
      return payload
    },
    onConfirmSend () {
      if (this.missingCount > 0) return
      this.saving = true
      request.common('violationAlertRecordCreate', this.buildPayload()).then(() => {
        this.$message.success('已保存违规预警消息（未真正执行处罚/推送）')
        this.confirmVisible = false
        this.goBack()
      }).finally(() => {
        this.saving = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.create-form {
  max-width: 720px;
}
.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin: 8px 0 16px;
  padding-top: 8px;
  border-top: 1px solid #ebeef5;
}
.section-title:first-child {
  border-top: 0;
  padding-top: 0;
  margin-top: 0;
}
.upload-tip,
.field-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.6;
  margin: 4px 0 12px 120px;
}
.el-form-item .field-tip {
  margin: 6px 0 0;
}
.blacklist-tips {
  color: #909399;
  font-size: 12px;
  line-height: 1.8;
  margin-top: 8px;
}
.danger-text { color: #f56c6c; }
.confirm-desc { margin-bottom: 12px; color: #606266; font-size: 13px; }
.confirm-warn { margin-top: 8px; color: #f56c6c; font-size: 12px; }
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 96px;
  height: 96px;
  line-height: 96px;
  text-align: center;
}
.avatar {
  width: 96px;
  height: 96px;
  display: block;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/violation-alert/pages/ViolationAlertCreate.vue